// extracted by mini-css-extract-plugin
export var deleteModal = "_gw-0";